import { useState, useEffect } from "react";
import {
  AccountInfo,
  InteractionRequiredAuthError,
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";
import { NavService, NavUrl } from "../services/NavService";
import { loginRequest } from "../authConfig";

export const useNavUrls = (
  inProgress: InteractionStatus,
  instance: IPublicClientApplication
): NavUrl[] => {
  const [navUrls, setNavUrls] = useState<NavUrl[]>([]);

  useEffect(() => {
    const navService = new NavService();

    const fetchNavUrls = async () => {
      if (inProgress === InteractionStatus.None) {
        try {
          const urls = await navService.getNavUrls(instance);
          setNavUrls(urls);
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          }
        }
      }
    };

    fetchNavUrls();
  }, [inProgress, instance]);

  return navUrls;
};
